import {PrivacyPolicy} from '../components/Disclaimers/PrivacyPolicy';

export const PrivacyPolicyPage = () => {
    return <PrivacyPolicy/>
};